// Shared projection-editor chrome: the persistent header bar and the four-step
// indicator. Lifted out of TeamEditor so the results page (ProjectionResults)
// can render the exact same header + step nav without a circular import
// (TeamEditor already imports ResultsView from ProjectionResults).
import theme from "../data/theme";
import { TEAM_META } from "../data/projectionData";
import { VEGAS_NOTES } from "../data/vegasNotes";

const { colors, fonts, fontSize, fontWeight } = theme;

// ── EditorHeader ──────────────────────────────────────────────────────────────

export function EditorHeader({ abbrev, teamColor, onBack, saveFlash, onOpenRankings, onViewResults }) {
  const meta = TEAM_META[abbrev];
  const vegas = VEGAS_NOTES[abbrev];
  const navBtnStyle = { background: "rgba(255,255,255,0.06)", border: `1px solid ${colors.border.default}`, borderRadius: 8, color: "#A0AEC0", padding: "6px 14px", fontSize: fontSize.small, cursor: "pointer", fontFamily: fonts.display, fontWeight: fontWeight.bold, flexShrink: 0 };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
      <div style={{ width: 5, height: 36, borderRadius: 3, background: teamColor, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{ fontFamily: fonts.display, fontSize: fontSize.title, fontWeight: fontWeight.black, margin: 0, letterSpacing: "1px", color: colors.text.primary }}>
          {meta.fullName.toUpperCase()}
        </h1>
        {vegas && (
          <div style={{ fontSize: fontSize.sub, color: colors.text.secondary, fontWeight: fontWeight.medium, marginTop: 3, whiteSpace: "nowrap" }}>
            2025 {vegas.rec2025} · Vegas {vegas.impliedPPG.toFixed(1)} PPG
          </div>
        )}
      </div>
      <span style={{ display: "flex", alignItems: "center", gap: 4, fontSize: fontSize.small, fontWeight: fontWeight.medium, color: "#A0AEC0", opacity: saveFlash ? 1 : 0, transition: "opacity 0.5s ease", flexShrink: 0, pointerEvents: "none" }}>
        ✓ Saved
      </span>
      <span style={{ fontSize: fontSize.micro, fontWeight: fontWeight.bold, color: colors.brand.accent, background: "rgba(255,149,0,0.12)", padding: "3px 10px", borderRadius: 5, fontFamily: fonts.display, flexShrink: 0 }}>
        2026 PROJECTION
      </span>
      {onOpenRankings && (
        <button onClick={onOpenRankings} style={navBtnStyle}>
          Rankings
        </button>
      )}
      {onViewResults && (
        <button onClick={onViewResults} style={navBtnStyle}>
          Final projection →
        </button>
      )}
      <button onClick={onBack} style={navBtnStyle}>
        ← Teams
      </button>
    </div>
  );
}

// ── StepIndicator ─────────────────────────────────────────────────────────────

export function StepIndicator({ activeIdx, onStepClick, maxIdx }) {
  const tabs = [
    { n: "1", l: "PLAYS",      step: "1a" },
    { n: "2", l: "SPLIT",      step: "1b" },
    { n: "3", l: "ALLOC",      step: "2" },
    { n: "4", l: "EFFICIENCY", step: "3" },
  ];
  return (
    <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
      {tabs.map((t, i) => {
        const done   = i < activeIdx;
        const active = i === activeIdx;
        const clickable = onStepClick && i <= maxIdx && i !== activeIdx;
        return (
          <div key={i}
            onClick={clickable ? () => onStepClick(t.step) : undefined}
            style={{
              flex: 1, padding: "8px 10px", borderRadius: 8, display: "flex", alignItems: "center", gap: 8,
              background: active ? "rgba(255,107,0,0.1)" : done ? "rgba(34,197,94,0.06)" : "rgba(255,255,255,0.02)",
              border: `1px solid ${active ? "rgba(255,107,0,0.3)" : done ? "rgba(34,197,94,0.15)" : colors.border.subtle}`,
              opacity: active || done ? 1 : clickable ? 0.7 : 0.35,
              cursor: clickable ? "pointer" : "default",
              transition: "background 0.15s",
          }}>
            <span style={{
              width: 22, height: 22, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: fontSize.caption, fontWeight: fontWeight.black, fontFamily: fonts.display,
              background: active ? colors.brand.orange : done ? "rgba(34,197,94,0.15)" : "rgba(255,255,255,0.08)",
              color: active ? "#fff" : done ? "#4ade80" : "#A0AEC0",
            }}>{done ? "✓" : t.n}</span>
            <span style={{ fontSize: fontSize.small, fontWeight: fontWeight.heavy, fontFamily: fonts.display, letterSpacing: "1px", color: active ? colors.text.primary : done ? "#4ade80" : "#A0AEC0" }}>{t.l}</span>
          </div>
        );
      })}
    </div>
  );
}
